import React, { useState } from 'react';
import {
  Alert,
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap';
import classnames from 'classnames';
import UsersTab from './UsersTab';
import SecurityTab from './SecurityTab';
import GeneralTab from './GeneralTab';
import RolesTab from './RolesTab';
import { hasPermission, hasModuleAccess } from '../../utils/permissions';

const Settings = () => {
  const showUsers = hasPermission('users.list');
  const showSecurity = hasPermission('settings.view');
  const showRoles = hasPermission('roles.list');
  const showGeneral = hasPermission('settings.view');
  const anyVisible = showUsers || showSecurity || showRoles || showGeneral;

  const defaultTab = showUsers ? 'users' : showRoles ? 'roles' : showSecurity ? 'security' : 'general';
  const [activeTab, setActiveTab] = useState(defaultTab);

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  if (!anyVisible) {
    return (
      <Container fluid className="p-4">
        <Alert color="warning">No tiene permisos para ver ninguna sección de configuración.</Alert>
      </Container>
    );
  }

  return (
    <Container fluid className="p-4">
      <h4 className="mb-4">Configuración del Sistema</h4>
      <Nav tabs className="mb-3">
        {showUsers && (
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === 'users' })}
              onClick={() => toggle('users')}
              style={{ cursor: 'pointer' }}
            >
              Usuarios
            </NavLink>
          </NavItem>
        )}
        {showSecurity && (
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === 'security' })}
              onClick={() => toggle('security')}
              style={{ cursor: 'pointer' }}
            >
              Seguridad
            </NavLink>
          </NavItem>
        )}
        {showRoles && (
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === 'roles' })}
              onClick={() => toggle('roles')}
              style={{ cursor: 'pointer' }}
            >
              Roles
            </NavLink>
          </NavItem>
        )}
        {showGeneral && (
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === 'general' })}
              onClick={() => toggle('general')}
              style={{ cursor: 'pointer' }}
            >
              General
            </NavLink>
          </NavItem>
        )}
      </Nav>
      <TabContent activeTab={activeTab}>
        {showUsers && (
          <TabPane tabId="users">
            <UsersTab />
          </TabPane>
        )}
        {showSecurity && (
          <TabPane tabId="security">
            <SecurityTab />
          </TabPane>
        )}
        {showRoles && (
          <TabPane tabId="roles">
            <RolesTab />
          </TabPane>
        )}
        {showGeneral && (
          <TabPane tabId="general">
            <GeneralTab />
          </TabPane>
        )}
      </TabContent>
    </Container>
  );
};

export default Settings;
